<template lang="pug">
  .card.height-100
    .card-body
      .columns.align-center
        .column.col-auto
          user-avatar.avatar-lg(:user="purchase.person")
        .column.text-ellipsis
          .text-bold.text-ellipsis {{ purchase.person.fullName }}
          .text-small {{ purchase.person.email }}
      .divider.text-center(data-content="Compra")
      .columns
        .column.col-12.text-ellipsis Status: #[small(:class="purchaseStatus.class") {{ purchase.status | purchaseStatus }}]
        .column.col-12.text-ellipsis Gateway: #[span.text-bold(:class="gateway.class") {{ gateway.label }}]
        .column.col-12.text-ellipsis Valor: #[span.text-bold(:class="purchase.status === 'canceled' ? 'line-through' : 'text-success'") {{ purchase.total | currency('R$ ') }}]
    .card-footer
      .columns.align-center
        .column
          .text-small Comprado em: #[span.text-bold {{ purchase.createdAt | toDate('DD/MM/YYYY HH:mm') }}]
      .columns
        .column
        .column.col-auto
          a.btn.btn-link.btn-actioon.btn-sm.tooltip(
            data-tooltip="Excluir"
            @click="requestDestroy"
          )
            i.fas.fa-trash.text-error
          router-link.btn.btn-link.btn-actioon.btn-sm.tooltip(
            data-tooltip="Exibir"
            :to="{ name: 'purchases.show', params: { id: purchase.id } }"
          )
            i.fas.fa-eye
</template>

<script>
import { mapGateway, purchaseStatus } from '@/lib/constants'
import purchases from '@/services/purchases'

export default {
  data() {
    return { loading: false }
  },
  props: { purchase: { type: Object, required: true } },
  computed: {
    gateway() {
      return mapGateway[this.purchase.paymentGatewayType] || {}
    },
    purchaseStatus() {
      return purchaseStatus[this.purchase.status] || {}
    },
  },
  methods: {
    async destroy() {
      try {
        this.loading = true
        await purchases.destroy(this.purchase.id)
        this.$toaster.success('Compra removida')
        this.$emit('removed')
      } catch (e) {
        this.$toaster.error(e.response.data.message)
      } finally {
        this.loading = false
      }
    },
    requestDestroy() {
      const options = {
        size: 'sm',
        title: 'Confirmar',
        cancelLabel: 'Cancelar',
      }
      this.$dialogs
        .confirm('Tem certeza que excluir essa compra?', options)
        .then(res => {
          if (res.ok) {
            this.destroy()
          }
        })
    },
  },
}
</script>
